import { TERMS_LINKS } from '@avalara/bat-apps-shared/lib/constants';
import { SRow, SCol } from '@avalara/skylab-sdk/react';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import IframePaymentContainer from '../../containers/iframe-payment-container';
import { updateProductAnalytics } from '../../lib/side-effects/analytics';
import { addRiskAssessmentOffer } from '../../lib/side-effects/offers';
import { selectState } from '../../selectors';
import ExternalLink from '../external-link';
import PaymentText from '../shared/payment/payment-text';
import PaymentSelection from '../shared/payment/payment-selection';
import { RelativeDiv } from '../styled/skylab/page';
import { setNeedToFetchCybersourceData } from '../../store/system';
const RiskAssessmentPaymentView = () => {
    const { account: { accountId, isAdmin, isLoggedIn, paymentMethods, selectedPaymentMethod, }, buyFlow: { hideIframe }, order: { discountAdditionalLegalText }, } = useSelector(selectState);
    const history = useHistory();
    const dispatch = useDispatch();
    const shouldHideIframe = selectedPaymentMethod !== null || (isLoggedIn && isAdmin === false);
    const onSubmit = () => {
        dispatch(updateProductAnalytics('buy_now'));
        return (accountId != null && selectedPaymentMethod != null)
            ? dispatch(addRiskAssessmentOffer({
                history,
                paymentToken: selectedPaymentMethod.Id,
                successPage: '/risk-assessment/thank-you',
            }))
            : undefined;
    };
    const disabled = (isLoggedIn && isAdmin === false);
    useEffect(() => {
        if (!shouldHideIframe) {
            dispatch(setNeedToFetchCybersourceData(true));
        }
        else {
            dispatch(setNeedToFetchCybersourceData(false));
        }
    }, [shouldHideIframe, hideIframe]);
    const showBuyButton = selectedPaymentMethod;
    const buttonText = !showBuyButton ? 'Finish' : 'Buy Now';
    return (React.createElement(RelativeDiv, null,
        isAdmin && !!paymentMethods.length && React.createElement(PaymentSelection, null),
        React.createElement(IframePaymentContainer, { hideIframe: shouldHideIframe }),
        React.createElement(PaymentText, null),
        React.createElement(SRow, null,
            React.createElement(SCol, { span: '9', className: 'flex flex-dir-col margin-bottom-lg pad-bottom-lg' },
                React.createElement("span", { className: 'get-started-button-container' }, showBuyButton && React.createElement("button", { "data-ref": 'buy.risk-assessment.payment.submit-button', id: 'submit-payment', disabled: disabled, onClick: onSubmit, className: 'button primary large buy-now' }, buttonText)),
                React.createElement("span", { className: 'get-started-text-link' },
                    "By clicking ",
                    buttonText,
                    " you accept our",
                    ' ',
                    React.createElement(ExternalLink, { href: TERMS_LINKS.esow, alwaysOpenInNewTab: true }, 'terms & conditions'),
                    React.createElement("br", null),
                    "and the",
                    ' ',
                    React.createElement(ExternalLink, { href: TERMS_LINKS.ps, alwaysOpenInNewTab: true }, 'Avalara Professional Services terms & conditions')),
                discountAdditionalLegalText != null &&
                    React.createElement("p", { className: 'margin-top-sm' }, discountAdditionalLegalText)))));
};
export default RiskAssessmentPaymentView;
